var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[_c('DragDrop',{attrs:{"uppy":_vm.uppy}}),_vm._v(" "),_c('StatusBar',{attrs:{"uppy":_vm.uppy,"props":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }